import React from 'react'
import {Card, Grid, Image, Divider, Header, Container} from 'semantic-ui-react'
import PersonalIcon from './PersonalIcon.jpg'
import {resume} from './resume'
import Social from './socials';

export default class Summary extends React.Component {
    Intro = () => {
        return (
            <Grid.Row columns={2}>
                <Grid.Column>
                    <Image className="center" src={PersonalIcon} size='small' circular/>
                </Grid.Column>
                <Grid.Column textAlign='left'>
                    <Header as='h2' className='obliq'>Welcome!</Header>
                    <Container className='obliq grayfont'>
                        <p>My name is Chien-Ting (Tim) Weng. You can call me CT.</p>
                        <p>I'm a software engineer and data analytics.</p>
                        <p>I enjoy discovering new technology and building things</p>
                        <Social size='large'/>
                    </Container>
                </Grid.Column>
            </Grid.Row>
        );
    }
    Skills = ({skills}) => {
        let keys = Object.keys(skills);
        return (
            <Grid.Row columns={3} className='obliq grayfont'>
                {keys.map((key)=>(
                    <Grid.Column key={key}>
                        <Header as='h5' textAlign='center'>{key}</Header>
                        <Divider />
                        <Container className='lightgrayfont'>
                            {skills[key].join(', ')}
                        </Container>
                    </Grid.Column>
                ))}
            </Grid.Row>
        );
    }
    render() {
        const skills = resume.basics.skills;
        const skillDom = this.Skills({skills});
        const introDom = this.Intro();
        return (
            <Card id='about' className='summary' fluid>
                <Card.Content>
                    <Card.Header textAlign='left'>About</Card.Header>
                </Card.Content>
                <Card.Content>
                    <Grid>
                        {introDom}
                        {skillDom}
                    </Grid>
                </Card.Content>
            </Card>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Infos/summary.js